import React, {useContext, useState, useEffect} from 'react';
import {FilterContext} from "@providers/filters";
import CitiesSelection from "./components/cities.selection";
import DistrictsSelection from "./components/districts.selection";
import PriceSelection from "./components/price.selection";
import DealTypeSelection from "./components/deal.type.selection";
import TypesSelection from "./components/types.selection";
import LoanFilter from "./components/loan.filter";
import HasMediaFilter from "./components/has.media.filter";
import {MoreFilterBtn} from "./components/more.filtes.btn";
import MortgageSelection from "./components/mortgage.selection";
import RentSelection from "./components/rent.selection";
import Badges from "@atoms/badges";
import FilterIcon from "@icons/filter.svg";
import {handleFiltersCount} from "@hooks/filters.manager";
import {isEmpty} from "@helpers/helpers";
import VillaTypesSelection from "./components/villa_types_selection";
import {getCityById} from "../../../models/district";
import HasVideoFilter from "./components/has.video.filter";

function SearchFilters({isBadeSaba, setModalFiltersShow, fluid, className, searchNavbarRef}) {
    const [selectedCity, setSelectedCity] = useState(null);
    const filters = useContext(FilterContext);
    const {selected_filters, loadings} = filters;
    const selectedFiltersCount = handleFiltersCount(selected_filters);

    useEffect(() => {
        if (!isEmpty(selected_filters.city_id)) {
            getCities();

            function getCities() {
                getCityById(selected_filters.city_id).then(city => {
                    setSelectedCity(city)
                }).catch(err => {
                    setTimeout(() => {
                        getCities();
                    }, 1000)
                });
            }
        }
    }, [selected_filters.city_id]);

    const showMobileFiltersSelected = (selectedFiltersCount.mobile > 0 && isBadeSaba) ? selectedFiltersCount.mobile - 1 : selectedFiltersCount.mobile;

    return (
        <div ref={searchNavbarRef} className={"search-filter " + (className ?? '')}>
            <div className="search-filter-wrapper">
                <div className={"d-flex " + (fluid ? 'container-fluid' : 'container')}>
                    <div className="more-search-filters form-group d-block d-md-none ml-8">
                        <button onClick={() => setModalFiltersShow(true)} className="btn-more-filter">
                            <FilterIcon/>
                            <span className="mr-8 ml-8">فیلترها</span>
                            {
                                (showMobileFiltersSelected > 0) ?
                                    <Badges color="primary" circle>{showMobileFiltersSelected}</Badges>
                                    : ''
                            }
                        </button>
                    </div>

                    <CitiesSelection
                        className={"form-group " + (isBadeSaba ? 'd-none' : '')}
                        items={filters.cities}
                        selected_filters={selected_filters}
                        isBadeSaba={isBadeSaba}
                    />

                    {
                        (!isEmpty(selectedCity) && selectedCity.type === 'city') ?
                            <DistrictsSelection
                                className="form-group"
                                items={filters.districts}
                                loading={(!isEmpty(loadings.districts) && loadings.districts)}
                                showSelectedItemsInTop/>
                            :
                            ''
                    }

                    <DealTypeSelection
                        className="form-group"
                        items={filters.deal_type}
                        loading={(!isEmpty(loadings.deal_type) && loadings.deal_type)}
                        city_id={selected_filters.city_id}
                        typesSelectedItems={filters.types.selected_items}
                    />

                    <TypesSelection
                        className="form-group"
                        loading={(!isEmpty(loadings.types) && loadings.types)}
                        city_id={!isEmpty(selectedCity) ? selectedCity.id : ''}
                        items={filters.types}
                    />

                    <VillaTypesSelection
                        className="form-group"
                        items={filters.villa_type}
                    />

                    <PriceSelection
                        className="form-group"
                        items={filters.price}
                    />

                    <MortgageSelection
                        className="form-group"
                        items={filters.mortgage}
                    />

                    <RentSelection
                        className="form-group"
                        items={filters.rent}
                    />

                    <HasMediaFilter
                        className="form-group ml-8"
                        items={filters.has_media}
                        selectBox/>

                    <HasVideoFilter
                        className="form-group ml-8"
                        items={filters.has_video}
                        selectBox/>



                    <LoanFilter
                        className="form-group ml-8"
                        items={filters.loan}
                        selectBox/>

                    <MoreFilterBtn
                        selectedFiltersCount={selectedFiltersCount.desktop}
                        setModalFiltersShow={setModalFiltersShow}/>

                </div>
            </div>
        </div>
    )
}

export default SearchFilters;